import { Routes } from '@angular/router';
import { buchungsbriefRoutes } from '@softapps/abau/buchungsbrief';
import { loginRoutes } from '@softapps/allgemein/login';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { passwordRoutes } from '@softapps/allgemein/password';
import { pdfEditorRoutes } from '@softapps/allgemein/pdf-editor';
import { ssoRoutes } from '@softapps/allgemein/sso';
import { connectionSettingsRoutes, settingsRoutes } from '@softapps/allgemein/utils';
import { freigabeRoutes } from '@softapps/fibu/freigabe';
import { haftruecklassRoutes } from '@softapps/fibu/haftruecklass';
import { offenePostenRoutes } from '@softapps/fibu/offene-posten';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { subkundenRoutes } from '@softapps/wws/subkunden';
import { AuthenticationGuard } from '@softline/auth';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      ...moduleRoutes,
      ...pdfEditorRoutes,
      ...settingsRoutes,
      ...gesamtabfrageRoutes,
      ...subkundenRoutes,
      ...freigabeRoutes,
      ...haftruecklassRoutes,
      ...offenePostenRoutes,
      ...buchungsbriefRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [
      ...loginRoutes,
      ...ssoRoutes,
      ...passwordRoutes,
      ...connectionSettingsRoutes,
      ...settingsRoutes,
    ],
  },
];
